import { Injectable } from "@angular/core";
import { HelperService } from "../shared/services/helper.service";
import { environment } from "../../environments/environment";
import { HttpService } from "../shared/services/http.service";
import {
    GiftCardOrderSalesModel, GiftCardVirtualsModel,
    GiftCardClientsModel, GiftCardContactModel, GiftCardTypesModel,
    GiftCardGroupModel, GiftCardModel, GiftCardVirtualsModelNCR
} from "../models/gifcardVirtual.model";

@Injectable()
export class GifcardVirtualService {
    private PARAMETER_ENDPOINT: string = '/giftCardVirtual';
    private BASE_URL: string = HelperService.buildRequestURL(environment.RipleyGiftCardVirtualApiEndPoint);
    private REQUEST_URL: string = `${this.BASE_URL}${this.PARAMETER_ENDPOINT}`;
    private URL: string;
    public TYPE_ORDER_SALES_VIRTUAL = "V";    

    constructor(private httpService: HttpService) { }

    public GetGiftCardOrderSales() {
        this.URL = `${this.REQUEST_URL}/getOrderSales`;
        return this.httpService.get<GiftCardOrderSalesModel[]>(this.URL);
    }

    public GetGiftCardClients() {
        this.URL = `${this.REQUEST_URL}/getClients`;
        return this.httpService.get<GiftCardClientsModel[]>(this.URL);
    }

    public GetGiftCardClientsAll() {
        this.URL = `${this.REQUEST_URL}/getClientsAll`;
        return this.httpService.get<GiftCardClientsModel[]>(this.URL);
    }

    public GetGiftCardModels() {
        this.URL = `${this.REQUEST_URL}/getModels`;
        return this.httpService.get<GiftCardModel[]>(this.URL);
    }

    public GetGiftCardModelsByType(params) {
        this.URL = `${this.REQUEST_URL}/getModelsByType`;
        return this.httpService.post<GiftCardModel[]>(this.URL, params);
    }

    public GetOrderSalesByStatus(params) {
        this.URL = `${this.REQUEST_URL}/getOrderSalesByStatus`;
        return this.httpService.post<GiftCardOrderSalesModel[]>(this.URL, params);
    }

    public GetOrderSalesByStatusAndUser(params) {
        this.URL = `${this.REQUEST_URL}/getOrderSalesByStatusAndUser`;
        return this.httpService.post<GiftCardOrderSalesModel[]>(this.URL, params);
    }

    public GetGiftCardVirtuals(order) {
        this.URL = `${this.REQUEST_URL}/getGiftCardsVirtuals`;
        return this.httpService.post<GiftCardVirtualsModel[]>(this.URL, order);
    }

    public GetGiftCardVirtualsNewCode(order) {
        this.URL = `${this.REQUEST_URL}/getGiftCardsVirtualsNewCode`;
        return this.httpService.post<GiftCardVirtualsModel[]>(this.URL, order);
    }

    public GenerateDataGiftcardsNCR(order) {
        this.URL = `${this.REQUEST_URL}/generateDataGiftcardsNCR`;
        return this.httpService.post<GiftCardVirtualsModelNCR[]>(this.URL, order);
    }

    public GetOrderSalesById(params) {
        this.URL = `${this.REQUEST_URL}/getOrderSalesById`;
        return this.httpService.post<GiftCardOrderSalesModel[]>(this.URL, params);
    }

    public GetGiftCardGroup(order) {
        this.URL = `${this.REQUEST_URL}/getGiftCardGroup`;
        return this.httpService.post<GiftCardGroupModel[]>(this.URL, order);
    }

    public GetContactByClient(client) {
        this.URL = `${this.REQUEST_URL}/getContactByClient`;
        return this.httpService.post<GiftCardContactModel[]>(this.URL, client);
    }

    public GetContactAllByClient(client) {
        this.URL = `${this.REQUEST_URL}/getContactAllByClient`;
        return this.httpService.post<GiftCardContactModel[]>(this.URL, client);
    }

    public GetGiftCardOrderSalesTiendaItems(item) {
        this.URL = `${this.REQUEST_URL}/getGiftCardOrderSalesTiendaItems`;
        return this.httpService.post<any>(this.URL, item);
    }

    public GroupActive(item) {
        this.URL = `${this.REQUEST_URL}/createGroupActive`;
        return this.httpService.post<any>(this.URL, item);
    }    

    public CreateOrderSales(orderSales) {
        this.URL = `${this.REQUEST_URL}/createOrderSales`;
        return this.httpService.post<any>(this.URL, orderSales);
    }

    public CreateClient(item) {
        this.URL = `${this.REQUEST_URL}/createClient`;
        return this.httpService.post<any>(this.URL, item);
    }

    public CreateContact(item) {
        this.URL = `${this.REQUEST_URL}/createContact`;
        return this.httpService.post<any>(this.URL, item);
    }

    public UpdateGiftCardByGroup(group) {
        this.URL = `${this.REQUEST_URL}/updateGiftCardByGroup`;
        return this.httpService.put<any>(this.URL, group);
    }

    public UpdateOrderSalesStatus(params) {
        this.URL = `${this.REQUEST_URL}/updateOrderSalesStatus`;
        return this.httpService.put<any>(this.URL, params);
    }

    public UpdateOrderSalesDistribution(params) {
        this.URL = `${this.REQUEST_URL}/updateOrderSalesDistribution`;
        return this.httpService.put<any>(this.URL, params);
    }

    public UpdateOrderSalesActivation(params) {
        this.URL = `${this.REQUEST_URL}/updateOrderSalesActivation`;
        return this.httpService.put<any>(this.URL, params);
    }

    public UpdateOrderSalesFacturacion(params) {
        this.URL = `${this.REQUEST_URL}/updateOrderSalesFacturacion`;
        return this.httpService.put<any>(this.URL, params);
    }

    public UpdateGiftCardBySingle(giftCard) {
        this.URL = `${this.REQUEST_URL}/updateGiftCardBySingle`;
        return this.httpService.put<any>(this.URL, giftCard);
    }

    public UpdateClient(client) {
        this.URL = `${this.REQUEST_URL}/updateClient`;
        return this.httpService.put<any>(this.URL, client);
    }

    public UpdateContact(contact) {
        this.URL = `${this.REQUEST_URL}/updateContact`;
        return this.httpService.put<any>(this.URL, contact);
    }

    public UpdateGiftCardDataPrint(giftCard) {
        this.URL = `${this.REQUEST_URL}/updateGiftCardDataPrint`;
        return this.httpService.put<any>(this.URL, giftCard);
    }

    public UpdateGiftCardSequenceNCR(params) {
        this.URL = `${this.REQUEST_URL}/updateGiftCardSequenceNCR`;
        return this.httpService.put<any>(this.URL, params);
    }

    public UpdateGiftCardSequenceNCRMassive(params) {
        this.URL = `${this.REQUEST_URL}/updateGiftCardSequenceNCRMassive`;
        return this.httpService.put<any>(this.URL, params);
    }
    /**Servicios NCR */
    public GetGiftCardTypes() {
        this.URL = `${this.REQUEST_URL}/getGiftCardTypes`;
        return this.httpService.get<GiftCardTypesModel[]>(this.URL);
    }

    public GetGiftCardFisicoCount(params) {
        this.URL = `${this.REQUEST_URL}/getGiftCardFisicoCount`;
        return this.httpService.post<GiftCardTypesModel[]>(this.URL, params);
    }

    public CreateGiftCardAssignationNCR(params) {
        this.URL = `${this.REQUEST_URL}/createGiftCardAssignationNCR`;
        return this.httpService.post<any>(this.URL, params);
    }

    public CreateGiftCardDistributionNCR(params) {
        this.URL = `${this.REQUEST_URL}/createGiftCardDistributionNCR`;
        return this.httpService.post<any>(this.URL, params);
    }

    public CreateGiftCardVirtualNCR(params) {
        this.URL = `${this.REQUEST_URL}/createGiftCardVirtualNCR`;
        return this.httpService.post<any>(this.URL, params);
    }

    public CreateGiftCardVirtualNCRMassive(params) {
        this.URL = `${this.REQUEST_URL}/createGiftCardVirtualNCRMassive`;
        return this.httpService.post<any>(this.URL, params);
    }

    public UpdateGiftCardStatusNCR(params) {
        this.URL = `${this.REQUEST_URL}/updateGiftCardStatusNCR`;
        return this.httpService.put<any>(this.URL, params);
    }

    public UpdateGiftCardStatusFisico(params) {
        this.URL = `${this.REQUEST_URL}/updateGiftCardStatusFisico`;
        return this.httpService.put<any>(this.URL, params);
    }

    /**Validate Google Captcha */
    public validateCaptcha(response: string) {
        let params = {
            "response": response
        };
        this.URL = `${this.REQUEST_URL}/validateCaptcha`;
        return this.httpService.post<any>(this.URL, params);
    }

    public setClientEdit(client: GiftCardClientsModel) {
        sessionStorage.setItem("client", JSON.stringify(client));
    }

    public getClientEdit() {
        return sessionStorage.getItem("client");
    }

    public removeClientEdit() {
        sessionStorage.removeItem("client");
    }
}